import React from 'react';
import { hot } from 'react-hot-loader';
import Header from './Header/Header';
import Switcher from './Switcher';
import Footer from './Footer/Footer';
import '../index.scss';

const App = () => (
	<div id="app">
		<Header />
		<div className="u_mainContainer">
			<Switcher />
		</div>
		<Footer />
	</div>
);

export default hot(module)(App);
